<script>
  import { query } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";
  import {
    Button,
    ImagePreview,
    Icon,
    Title,
    handleDownload,
    isPdf,
    isImage,
    testImage,
  } from "t2c-components";

  import { client } from "apollo.js";
  import { DOCUMENT_CLIENT_QUERY } from "./queries.js";
  import { markAsReadDocument, auditReadDocument } from "./actions.js";

  import Breadcrumbs from "components/Breadcrumbs.svelte";
  import DocumentViewer from "components/DocumentViewer.svelte";
  import NoPreview from "components/NoPreview.svelte";

  export let lawcaseId;
  export let documentId;

  let links = [null, null, null];

  const clientDoc = query(client, {
    query: DOCUMENT_CLIENT_QUERY,
    variables: { lawcaseId, documentId },
  });

  let url;
  clientDoc.result().then((result) => {
    const authToken = localStorage.getItem("client-token");
    const folder = result.data.lawcaseClient.document.folder;
    const docId = result.data.lawcaseClient.document.id;
    const docPath = result.data.lawcaseClient.document.filePath;
    url = `/download-file/lawcase/${lawcaseId}/documents/${docId}/original/${docPath}?token=${authToken}`;

    links = [
      {
        to: `/lawcase/${lawcaseId}/folders`,
        label: result.data.lawcaseClient.title,
      },
      folder
        ? {
            to: `/lawcase/${lawcaseId}/folder/${folder.id}`,
            label:
              `${folder.name}` == "Inbox"
                ? $t("content.myDocuments")
                : `${folder.name}`,
          }
        : null,
      {
        to: `/lawcase/${lawcaseId}/document/${documentId}`,
        label: `${result.data.lawcaseClient.document.title}`,
      },
    ].filter((l) => !!l);

    markAsReadDocument(lawcaseId, documentId);
    auditReadDocument(lawcaseId, documentId);
  });

  let failedToLoad = false;
  $: {
    if (url) {
      testImage(url).catch((e) => {
        failedToLoad = true;
      });
    }
  }
</script>

<div class="container">
  <section class="wrapper">
    <Breadcrumbs {links} />
    {#await $clientDoc}
      <div class="box">
        <Title title={$t("content.documents")} />
        <p>{$t("loading")}</p>
      </div>
    {:then result}
      <div class="box">
        <div class="box-header line">
          <Title title={$t("document.preview")} />
          <div class="info">
            <div data-tooltip={$t("document.downloadFile")}>
              <Button style="inline" on:click={() => handleDownload(url)}>
                <Icon icon="download" />
                {$t("document.download")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {#if isPdf(result.data.lawcaseClient.document.fileType)}
        <DocumentViewer {url} doc={result.data.lawcaseClient.document} />
      {:else if isImage(result.data.lawcaseClient.document.fileType) && !failedToLoad}
        <ImagePreview {url} />
      {:else}
        <NoPreview on:click={() => handleDownload(url)} />
      {/if}
    {/await}
  </section>
</div>

<style>
  .container {
    width: 100%;
    font-weight: 400;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
  }

  .box {
    padding-top: 24px;
  }

  .box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .line {
    border-bottom: 1px solid var(--blue-color);
    margin-bottom: 12px;
  }
</style>
